
import { Options, Vue } from "vue-class-component";
import { filterData } from "../data/functions";
import { MutationTypes } from "../store/mutation-types";
import { useStore } from "../store";

@Options({
  props: {
    route: String,
  },
  methods: {
    //pushes to the state the guests/events that match the search
    handleSearch(value: string) {
      return this.store.commit(MutationTypes.SET_SEARCH, value);
    },
  },
})
export default class SearchBar extends Vue {
  route!: string;
  filterData = filterData;
  store = useStore();
}
